"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.correctionRequestsResponseSchema = exports.correctionWorkflowMeResponseSchema = exports.correctionDesignationsResponseSchema = exports.correctionUserRefSchema = void 0;
const zod_1 = require("zod");
const financial_payment_correction_response_1 = require("./financial-payment-correction.response");
const financial_receipt_correction_response_1 = require("./financial-receipt-correction.response");
const financial_patient_correction_response_1 = require("./financial-patient-correction.response");
const financial_ip_drug_cancel_response_1 = require("./financial-ip-drug-cancel.response");
const financial_appointment_correction_response_1 = require("./financial-appointment-correction.response");
exports.correctionUserRefSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string(),
    email: zod_1.z.string(),
});
exports.correctionDesignationsResponseSchema = zod_1.z.object({
    verifiers: zod_1.z.array(exports.correctionUserRefSchema),
    approvers: zod_1.z.array(exports.correctionUserRefSchema),
    /** Everyone an administrator may select: active, able to log in. */
    candidates: zod_1.z.array(exports.correctionUserRefSchema),
});
/** What the signed-in user can do in the workflow — drives the header link and which buttons a row shows. */
exports.correctionWorkflowMeResponseSchema = zod_1.z.object({
    isVerifier: zod_1.z.boolean(),
    isApprover: zod_1.z.boolean(),
    /** At least one verifier and one approver are set, and two different people can fill the two stages. Until then no request can be entered. */
    configured: zod_1.z.boolean(),
    /** Requests waiting for THIS user as a verifier (not ones they entered). */
    awaitingMyVerification: zod_1.z.number().int(),
    /** Requests waiting for THIS user as an approver (not ones they entered or verified). */
    awaitingMyApproval: zod_1.z.number().int(),
});
exports.correctionRequestsResponseSchema = zod_1.z.object({
    payment: zod_1.z.array(financial_payment_correction_response_1.paymentCorrectionRequestSchema),
    receipt: zod_1.z.array(financial_receipt_correction_response_1.receiptCorrectionRequestSchema),
    /** Patient-details edit requests (desk, 2026-10-07). Absent = none. */
    patient: zod_1.z.array(financial_patient_correction_response_1.patientEditRequestSchema).optional(),
    /** IP drug bill cancel requests (owner, 2026-10-17). Absent = none. */
    drugEntry: zod_1.z.array(financial_ip_drug_cancel_response_1.ipDrugEntryCancelRequestSchema).optional(),
    /** Appointment edit requests (APPTEDIT, desk 2026-10-18). Absent = none. */
    appointment: zod_1.z.array(financial_appointment_correction_response_1.appointmentEditRequestSchema).optional(),
});
//# sourceMappingURL=financial-correction-workflow.response.js.map